import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class Package {
  id: number;
  name: string;
  status: boolean;
  sku: string;

  @Expose({ name: 'sort_order' })
  sortOrder: number;

  price: string;
  bv: string;
  expiry?: number;
  image?: string;
  description?: string;

  @Expose({ name: 'max_levels' })
  maxLevels?: number;

  @Expose({ name: 'direct_bonus' })
  directBonus?: string;

  @Expose({ name: 'roi_bonus' })
  roiBonus?: string;

  constructor(
    id: number,
    name: string,
    status: boolean,
    sku: string,
    sortOrder: number,
    price: string,
    bv: string,
    expiry?: number,
    image?: string,
    description?: string,
    maxLevels?: number,
    directBonus?: string,
    roiBonus?: string
  ) {
    this.id = id;
    this.name = name;
    this.status = status;
    this.sku = sku;
    this.sortOrder = sortOrder;
    this.price = price;
    this.bv = bv;
    this.expiry = expiry;
    this.image = image;
    this.description = description;
    this.maxLevels = maxLevels;
    this.directBonus = directBonus;
    this.roiBonus = roiBonus;
  }

  static fromJson(json: Record<string, any>): Package {
    return plainToInstance(Package, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
